<template>
  <v-container fluid>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div class="mt-6" v-if="!loading">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <div v-if="list">
        <div v-if="list.property_id">
          <v-card height="100%" elevation="0" class="pa-md-5">
            <v-row>
              <v-col cols="12" md="4">
                <v-sheet
                  color="blue"
                  height="240"
                  v-if="!list.property_id.pictures"
                >
                  <v-row class="fill-height" align="center" justify="center">
                    <div class="display-3">NO Images</div>
                  </v-row>
                </v-sheet>
                <v-carousel hide-delimiters class="mb-5 pr-md-9" height="240">
                  <v-carousel-item
                    v-for="(item, i) in list.property_id.pictures"
                    :key="i"
                    :src="
                      $store.state.baseUrl +
                        'listing/thumb320x240-' +
                        item.file_name
                    "
                  >
                  </v-carousel-item>
                </v-carousel>
              </v-col>
              <v-col md="8" cols="12">
                <h1 class="text-h6">
                  {{ $t("TripTo") }} {{ list.property_id.name }}
                </h1>
                <div class="pb-5 text-capitalize">
                  <span>
                    <v-icon small class="gray--text"
                      >mdi-map-marker-radius</v-icon
                    >
                    {{ list.property_id.location }}
                  </span>
                </div>
                <v-row>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("TripStatus") }}
                    </div>
                    <div class="subtitle-2 pb-3">
                      {{ $t(list.booking_status) }}
                    </div>
                    <div class="overline grey--text">
                      {{ $t("Checkin") }}
                    </div>
                    <div class="subtitle-2 pb-3">
                      {{
                        format(
                          new Date(list.booking_details.dates[0] + "T00:00"),
                          "eee, do MMM, yyyy"
                        )
                      }}
                      - {{ list.booking_details.check_in_time }}
                    </div>
                    <div class="overline grey--text">
                      {{ $t("Guestsdetails") }}
                    </div>
                    <div class="subtitle-2 pb-3">
                      <span v-if="list.guest_details.no_adults">
                        <span class="" v-if="list.guest_details.no_adults == 1">
                          {{ $tc("Adult", 1) }}</span
                        >
                        <span class="" v-if="list.guest_details.no_adults > 1">
                          {{ $tc("Adult", 2) }}</span
                        >
                        :
                        {{ list.guest_details.no_adults }}
                      </span>
                      <span v-if="list.guest_details.no_childrens >= 1">
                        ,
                        <span
                          class="ml-2"
                          v-if="list.guest_details.no_childrens == 1"
                        >
                          {{ $tc("Children", 1) }}</span
                        >
                        <span
                          class="ml-2"
                          v-if="list.guest_details.no_childrens > 1"
                        >
                          {{ $tc("Children", 2) }}</span
                        >
                        :
                        {{ list.guest_details.no_childrens }}
                      </span>
                    </div>
                    <div v-if="list.contract_url" class="subtitle-2 pb-3">
                      <a
                        target="_blank"
                        :href="$store.state.serverUrl + list.contract_url"
                        @click.stop
                      >
                        {{ $t("REA") }}
                      </a>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("Tripid") }}
                    </div>
                    <div class="subtitle-2 pb-3">{{ list._id }}</div>
                    <div class="overline grey--text">
                      {{ $t("Checkout") }}
                    </div>
                    <div class="subtitle-2">
                      {{
                        format(
                          new Date(list.booking_details.dates[1] + "T00:00"),
                          "eee, do MMM, yyyy"
                        )
                      }}
                      - {{ list.booking_details.check_out_time }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("BookedFor") }}
                    </div>
                    <div class="subtitle-2 pb-3">
                      {{ list.booking_details.no_days }}
                      {{ $t("Nights") }}
                    </div>
                    <div class="pb-3">
                      <v-btn
                        v-if="
                          list.booking_status == 'bs1' ||
                            list.booking_status == 'bs2'
                        "
                        color="red"
                        block
                        dark
                        :to="{
                          name: 'PartnerCancelBookingComponent',
                          params: { id: list._id }
                        }"
                      >
                        {{ $t("CancelTrip") }}
                      </v-btn>
                    </div>
                    <div
                      v-if="
                        list.booking_status == 'bs2' ||
                          list.booking_status == 'bs6'
                      "
                    >
                      <v-dialog v-model="editDialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            block
                            color="light-blue"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $t("ChangeTripStatus") }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="light-blue darken-4 white--text">
                            {{ $t("ChangeTripStatus") }}
                          </v-card-title>
                          <v-card-text class="pa-5">
                            <v-select
                              v-model="editedTripStatus"
                              :items="statusList"
                              item-value="value"
                              :label="$t('TripStatus')"
                              outlined
                              @change="updateBookingStatus"
                            >
                              <template slot="selection" slot-scope="{ item }">
                                {{ $t(item.value) }}
                              </template>
                              <template slot="item" slot-scope="{ item }">
                                {{ $t(item.value) }}
                              </template>
                            </v-select>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" dark @click="editDialog = false">
                              {{ $t("Close") }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <h2 class="text-h6 py-5">{{ $t("Paymentdetails") }}</h2>
            <v-row>
              <v-col cols="12">
                <v-sheet class="text-center pa-5" color="grey lighten-4">
                  <v-simple-table class="pa-3 grey lighten-4">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left"></th>
                          <th class="text-left">{{ $t("BookingAmount") }}</th>
                          <th class="text-left">{{ $t("Fees") }}</th>
                          <th class="text-left">{{ $t("PaymentId") }}</th>
                          <th class="text-left">{{ $t("PaymentDue") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in list.payments" :key="i">
                          <td class="text-left">
                            {{ $t(item.payment_type) }}
                          </td>
                          <td class="text-left">
                            {{ item.currency_code }} {{ item.amount }}
                          </td>
                          <td class="text-left">
                            {{ item.currency_code }} {{ item.cleaning_fee }}
                          </td>
                          <td class="text-left">{{ item.payment_id }}</td>
                          <td class="text-left">
                            <p
                              class="caption ma-0"
                              v-if="item.payment_status == 'Unpaid'"
                            >
                              {{ formatDate(item.dateDue) }}
                            </p>
                            <p v-else>{{ item.payment_status }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4" class="text-right font-weight-bold">
                            {{ $t("s1655240471") }}
                          </td>
                          <td class="text-left font-weight-bold">
                            {{ list.payments[0].currency_code }}
                            {{ calculateTotal(list.payments) }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
          <AboutMemberComponent
            v-if="
              (list.booking_status == 'bs6' || list.booking_status == 'bs7') &&
                member_review == 0
            "
            :data="{
              booking_id: parm,
              property_id: list.property_id._id,
              member_id: list.user_id
            }"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import AboutMemberComponent from "@/components/feedback/AboutMemberComponent.vue";
import timeoutMixin from "@/mixins/timeoutMixin.js";
import PartnerService from "@/services/PartnerService";
import { format } from "date-fns";

export default {
  name: "BookingViewComponent",
  mixins: [timeoutMixin],
  components: { AboutMemberComponent },
  data() {
    return {
      format,
      loading: true,
      list: [],
      parm: this.$route.params.id,
      error: null,
      editDialog: false,
      reqRules: [value => !!value || this.$t("string719")],
      statusList: [{ value: "bs2" }, { value: "bs6" }],
      editedTripStatus: null,
      member_review: 0,
      reviewData: {}
    };
  },
  computed: {
    computedClass() {
      let className = "";
      if (this.list.payment_status == "Approved") {
        className = "light-green white--text";
      } else if (this.list.payment_status == "Pending") {
        className = "red darken-1 white--text";
      }
      return className;
    }
  },
  created: function() {
    this.getBooking();
  },
  methods: {
    calculateTotal(val) {
      if (!val) return "";
      let amounts = val
        .map(e => parseFloat(e.amount) + parseFloat(e.cleaning_fee))
        .reduce((prev, curr) => prev + curr, 0)
        .toFixed(2);
      return amounts;
    },
    getBooking() {
      PartnerService.bookingView({
        id: this.parm
      })
        .then(async result => {
          this.loading = false;
          const resultList = await result.data.list;
          this.member_review = await result.data.review;
          let {
            property_id: { pictures }
          } = resultList;
          pictures && pictures.sort((a, b) => a.order - b.order);
          this.list = { ...resultList, pictures };
        })
        .catch(err => {
          this.error = err.response.data.error;
          this.loading = false;
        });
    },
    formatDate(val) {
      return this.format(new Date(val), "eee, do MMM, yyyy");
    },
    updateBookingStatus() {
      this.editDialog = false;
      this.waitDialog = true;
      PartnerService.updateTripStatus({
        id: this.parm,
        trip_status: this.editedTripStatus
      })
        .then(() => {
          this.list.booking_status = this.editedTripStatus;
          setTimeout(() => (this.waitDialog = false), 500);
        })
        .catch(err => {
          this.error = err.response.data.errors;
          setTimeout(() => (this.waitDialog = false), 500);
        });
    }
  }
};
</script>

<style></style>
